import signInIM, { SignInType } from './signInIM';
import { changeSignInState, setProcessingManualSignIn } from '../actions/presenceActions';
import abandonAllChats from '../chatManager/abandonAllChats';
import { getStore } from '../store/presenceStore';
import ChatSignInState from '../store/schema/ChatSignInState';

const SIGN_IN_NOTIFICATION_TIMEOUT_IN_MILLISECONDS = 10 * 1000;
let setServiceNotAvailableTimer: number = 0;
let isServiceAvailable: boolean = false;

export default function setServiceAvailability(isAvailableNew: boolean) {
    clearSetServiceNotAvailableTimer();

    const isAvailableOld = isServiceAvailable;
    isServiceAvailable = isAvailableNew;

    if (!isAvailableNew) {
        if (isAvailableOld) {
            abandonAllChats();
        }
        retrySignInOrGiveUp();
    }
}

export function setServiceNotAvailableIfTimeout() {
    setServiceNotAvailableTimer = window.setTimeout(() => {
        if (getStore().signInState != ChatSignInState.SignedIn) {
            setServiceAvailability(false /*signedIn*/);
        }
    }, SIGN_IN_NOTIFICATION_TIMEOUT_IN_MILLISECONDS);
}

export function clearSetServiceNotAvailableTimer() {
    if (setServiceNotAvailableTimer) {
        window.clearTimeout(setServiceNotAvailableTimer);
        setServiceNotAvailableTimer = 0;
    }
}

function retrySignInOrGiveUp() {
    const signInState = getStore().signInState;
    if (
        signInState == ChatSignInState.AttemptingSignIn ||
        signInState == ChatSignInState.SignedIn ||
        signInState == ChatSignInState.Error
    ) {
        if (!signInIM(SignInType.Retry)) {
            setProcessingManualSignIn(false /*isManualSignIn*/);
            changeSignInState(ChatSignInState.Error);
        }
    }
}
